module.exports = __webpack_public_path__ + "static/giantTrophy-89145470fae575e92c4eb6fa0d5ac420.jpg";